import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header/header.js';
import Footer from './components/Footer/footer.js';
import Akwaba from './pages/Akwaba/akwaba.js';
import NotFound from './pages/NotFound/notFound.js';
import Formations from './pages/Formations/formations.js';
import Bts from './pages/Cycles/BTS/bts.js';
import Lmd from './pages/Cycles/LMD/lmd.js';
import VieUniversitaire from './pages/VieUniversitaire/vieUniversitaire.js';
import EspaceEtudiants from './pages/EspaceEtudiants/espaceEtudiants.js';
import Bibliotheque from './pages/Bibliotheque/bibliotheque.js';

function ExternalRedirect() {
    useEffect(() => {
        window.location.href = "https://escaccsanpedro.com/centre-de-travail-iusse-administration/";
    }, []);

    return <div className="redirect-message">Redirection en cours...</div>;
}

function App() {
	return (
		<div className="App">
			<Header />
			<main className="site-main">
				<Routes>
					<Route path="/" element={<Akwaba />} />
					<Route path="*" element={<NotFound />} />
					<Route path="akwaba" element={<Akwaba />} />
					<Route path="formations" element={<Formations />} />
					<Route path="/cycles/bts" element={<Bts />} />
					<Route path="/cycles/lmd" element={<Lmd />} />
					<Route path="vieUniversitaire" element={<VieUniversitaire />} />
					<Route path="espaceEtudiants" element={<EspaceEtudiants />} />
					<Route path="bibliotheque" element={<Bibliotheque />} />
					<Route path="ctia" element={<ExternalRedirect />} />
				</Routes>
			</main>
			<Footer />
		</div>
	);
}

export default App;
